import React from 'react'
import { NAPA_BATTERY_TITLE } from '../../utils/constants/GlobalConstants';
import Navbar from '../common/header/NavBar';
const pages = ["Home"];
const settings = [ "Logout"];

const Header = () => {     
  return (
    <Navbar title = {NAPA_BATTERY_TITLE} pages = {pages} settings = {settings}/>
  )
}

export default Header